module.exports = __webpack_public_path__ + "static/img/btn-bg-blue.bc2b9dd2.png";